import { StockReturns } from "@/features/analysis/services/symbol-info";

export const performanceDate = ["1D", "1M", "3M", "6M", "1Y", "YTD"] as const;
export type PerformanceDate = (typeof performanceDate)[number];

export const performanceMap: Record<PerformanceDate, keyof StockReturns> = {
  YTD: "ytdReturn",
  "1D": "oneDayReturn",
  "1M": "oneMonthReturn",
  "3M": "threeMonthsReturn",
  "6M": "halfYearReturn",
  "1Y": "oneYearReturn",
};
